<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1000px"
      show-save-button
      unit="学生信息"
      edit-title
      id-key="StudentId"
      :data="data"
      form-label-width="85px"
      :form-rules="rules"
      @create-opened="onCreateOpened"
      @opened="onOpened"
      :before-save="onBeforeSave"
      :save-func="api.save"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <div :class="isMB?'':'student_info'">
          <div class="right" v-if="isMB">
            <pic-upload ref="picUpload" :data="{dic:'Student'}" v-model="data.Photo" />
          </div>
          <div class="left">
            <!-- <template v-if="isEdit">
              <el-row>
                <el-col :span="isMB?24:8">
                  <el-form-item label="当前班级">
                    <span>{{data.CurrentClassName}}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="isMB?24:8">
                  <el-form-item label="当前宿舍">
                    <span>{{data.CurrentDormitory}}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="isMB?24:8">
                  <el-form-item label="座位号">
                    <span>{{data.CurrentSeatNumber}}</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </template> -->
            <el-row>
              <!-- <el-col :span="isMB?24:12">
                <el-form-item label="学期" prop="TermId">
                  <select-input
                    placeholder="选择学期"
                    :label="data.TermName"
                    v-model="data.TermId"
                    @click="openTermDialog"
                  />
                </el-form-item>
              </el-col> -->
              <el-col :span="isMB?24:8">
                <el-form-item label="学校名称" prop="SchoolId">
                  <el-select size="mini" v-model="data.SchoolId" style="width:100%;">
                    <el-option v-for="item in schoolList" :key="item.SchoolId" :value="item.SchoolId" :label="item.SchoolName"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="isMB?24:8">
                <el-form-item label="学生编号" prop="StudentNumber">
                  <el-input size="mini" v-model="data.StudentNumber" placeholder="请填写学生编号"></el-input>
                  <!-- <span>{{data.StudentNumber}}</span> -->
                </el-form-item>
              </el-col>
              <el-col :span="isMB?24:8">
                <el-form-item label="学生姓名" prop="FullName">
                  <el-input size="mini" v-model="data.FullName" placeholder="请填写学生姓名"></el-input>
                  <!-- <span>{{data.FullName}}</span> -->
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="isMB?24:8">
                <el-form-item label="卡号" prop="CardNumber">
                  <el-input size="mini" v-model="data.CardNumber" maxlength="10" ref="cardInp" placeholder="请填写卡号"></el-input>
                  <!-- <span>{{data.CardNumber}}</span> -->
                </el-form-item>
              </el-col>
              <el-col :span="isMB?24:8">
                <el-form-item label="学生短号" prop="ShortNum">
                  <el-input size="mini" v-model="data.ShortNum" type="number" placeholder="请填写学生短号"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="isMB?24:8">
                <el-form-item label="宿舍号" prop="DormitoryNo">
                  <el-input size="mini" v-model="data.DormitoryNo" placeholder="请填写宿舍号"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="isMB?24:8">
                <el-form-item label="家长姓名1" prop="ParentName1">
                  <el-input size="mini" v-model="data.ParentName1" placeholder="请填写家长姓名1"></el-input>
                  <!-- <span>{{data.ParentName1}}</span> -->
                </el-form-item>
              </el-col>
              <el-col :span="isMB?24:8">
                <el-form-item label="联系电话1" prop="ContactNumber1">
                  <el-input size="mini" v-model="data.ContactNumber1" type="number" placeholder="请填写联系电话1"></el-input>
                  <!-- <span>{{data.ContactNumber11}}</span> -->
                </el-form-item>
              </el-col>
              <el-col :span="isMB?24:8">
                <el-form-item label="称呼1" prop="Alias1">
                  <el-input size="mini" v-model="data.Alias1" placeholder="请填写称呼1"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="isMB?24:8">
                <el-form-item label="家长姓名2" prop="ParentName2">
                  <el-input size="mini" v-model="data.ParentName2" placeholder="请填写家长姓名2"></el-input>
                  <!-- <span>{{data.ParentName2}}</span> -->
                </el-form-item>
              </el-col>
              <el-col :span="isMB?24:8">
                <el-form-item label="联系电话2" prop="Call2">
                  <el-input size="mini" v-model="data.Call2" type="number" placeholder="请填写联系电话2"></el-input>
                  <!-- <span>{{data.Call2}}</span> -->
                </el-form-item>
              </el-col>
              <el-col :span="isMB?24:8">
                <el-form-item label="称呼2" prop="Alias2">
                  <el-input size="mini" v-model="data.Alias2" placeholder="请填写称呼2"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="isMB?24:8">
                <el-form-item label="家长姓名3" prop="ParentName3">
                  <el-input size="mini" v-model="data.ParentName3" placeholder="请填写家长姓名3"></el-input>
                  <!-- <span>{{data.ParentName1}}</span> -->
                </el-form-item>
              </el-col>
              <el-col :span="isMB?24:8">
                <el-form-item label="联系电话3" prop="ContactNumber3">
                  <el-input size="mini" v-model="data.ContactNumber3" type="number" placeholder="请填写联系电话3"></el-input>
                  <!-- <span>{{data.ContactNumber3}}</span> -->
                </el-form-item>
              </el-col>
              <el-col :span="isMB?24:8">
                <el-form-item label="称呼3" prop="Alias2">
                  <el-input size="mini" v-model="data.Alias3" placeholder="请填写称呼3"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="isMB?24:8">
                <el-form-item label="入学日期" prop="InDate">
                  <el-date-picker type="date" v-model="data.InDate" value-format="yyyy-MM-dd" placeholder="请选择入学日期" :style="isMB?'width:100%;':'width:172px;'"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="right" v-if="!isMB">
            <pic-upload ref="picUpload" :data="{dic:'Student'}" v-model="data.Photo" />
          </div>
        </div>
      </template>
    </common-dialog>
    <term-dialog ref="termDialog" in-dialog selectable :multiple="false" @select="setTerm" />
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import termDialog from "@/components/ed/term/listDialog";
import picUpload from "./picUpload";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    termDialog,
    picUpload,
  },
  data() {
    return {
      data: {
        SchoolId: null, //学校
        StudentId: 0,
        TermId: null, //学期ID
        TermNumber: "", //学期编号
        StudentNumber: "", //学生编号
        FullName: "", //姓名
        CardNumber: "", //卡号
        DormitoryNo: "", //宿舍号 
        ShortNum: "", //短号
        ParentName1: "", //家长姓名1
        Alias1: "", //称呼1
        ContactNumber1: "", //联系电话1
        ParentName2: "", //家长姓名2
        Alias2: "", //称呼2
        Call2: "", //联系电话2
        ParentName3: "", //家长姓名3
        Alias3: "", //称呼3
        ContactNumber3: "", //联系电话3
        Photo: "", //相片
        InDate: "",
      
        CurrentClassId: null,
        CurrentClassName: null,
        CurrentDormitory: null,
        CurrentDormitoryId: null,
        CurrentSeatNumber: null,
      },
      api: require("@/api/st/student").default,
      schoolApi: require("@/api/st/school").default,
      isMB: this.$store.state.isMB,
      schoolList: [],
      rules: {
        SchoolId: [{ required: true, message: "请选择学校" }],
        Grade: [{ required: true, message: "请填写年级" }],
        TermId: [{ required: true, message: "请选择学期" }],
        InDate: [{ required: true, message: "请选择入学日期" }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened(data) {
      console.log("onCreateOpened", data);
    },
    onOpened() {
      this.isEdit = this.$refs.dialog.isEdit;
      this.schoolApi.list({ Status: 1 }).then(res => {
        if(res.Code == 0) {
          this.schoolList = res.Data;
        }
      })
      this.$refs.cardInp.focus();
    },
    openTermDialog() {
      this.$refs.termDialog.open().then((that) => {
        that.getData();
      });
    },
    setTerm(t) {
      console.log(t);
      this.data.TermId = t.TermId;
      this.data.TermName = t.TermName;
    },
    onBeforeSave() {
      if(this.data.ContactNumber1&&this.data.ContactNumber1.length != 11) {
        this.$message.error("请填写11位手机号码")
        return false;
      }
      if(this.data.Call2&&this.data.Call2.length != 11) {
        this.$message.error("请填写11位手机号码")
        return false;
      }
      if(this.data.ContactNumber3&&this.data.ContactNumber3.length != 11) {
        this.$message.error("请填写11位手机号码")
        return false;
      }
    },
  },
};
</script>
<style lang="scss">
.student_info {
  display: flex;
  display: -webkit-flex;
  .left {
    width: 770px;
  }
  .right {
    width: calc(100% - 770px);
  }
  // .__image-buttons,.upload_btn{
  //   visibility: hidden;
  // }
}
</style>